import { Box, Typography, Grid, styled } from '@mui/material';

import { IApplication } from '../../../interfaces/common.interface';
import Logo from '../../../assets/images/converge-logo-light.png';

const Header = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '1.75rem',
  marginBottom: '2rem',
}));

const Data = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontSize: '1rem',
}));

const InformationForm = ({ title, info }: { title: string; info: IApplication | undefined }) => {
  return (
    <>
      <Box component='img' src={Logo} sx={{ maxWidth: '18.75rem', mt: '2rem', mb: '2rem' }} />

      <Typography sx={{ fontSize: '1.75rem', mb: '2rem' }} color='primary'>
        {title}
      </Typography>

      <Box sx={{ width: '100%', marginY: '2rem' }}>
        <Header>Information</Header>

        <Grid container spacing={2} sx={{ borderRadius: '0.5rem' }}>
          <Grid item md={4} xs={12} sx={{ display: 'flex', flexDirection: 'column' }} gap={0.5}>
            <Data>
              Name: {info?.firstname} {info?.middlename} {info?.lastname}
            </Data>
            <Data>Birthdate:{info?.birthdate}</Data>
            <Data>Email Address: {info?.email_address}</Data>
            <Data>Mobile Number: {info?.mobile_no}</Data>
            <Data>Employee Code: {info?.code}</Data>
            <Data>Date Hired: {info?.hiring_date}</Data>
          </Grid>

          <Grid item md={4} xs={12} sx={{ display: 'flex', flexDirection: 'column' }} gap={0.5}>
            <Data>Base of Assignment: {info?.base_of_assignment}</Data>
            <Data>Position: {info?.position}</Data>
            <Data>Department: {info?.department}</Data>
            <Data>Affiliate Description: {info?.company}</Data>
          </Grid>

          <Grid item md={4} xs={12} sx={{ display: 'flex', flexDirection: 'column' }} gap={0.5}>
            <Data>Effective Date of Separation: {info?.effective_separation_date}</Data>
            <Data>Date of Clearance Application: {info?.clearance_application_date}</Data>
            <Data>Reason for Separation: {info?.reason}</Data>
            {info?.dissatisfaction_cause && (
              <Data>Authorized Cause: {info?.dissatisfaction_cause}</Data>
            )}
            {<Data>Last Working Day: {info?.last_working_day}</Data>}
            {info?.completion_date && <Data>Completion Date: {info?.completion_date}</Data>}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default InformationForm;
